import { Box } from '@mui/material';
import React from 'react';
import useStockPrice from './hook/use-stock-price-layout';
import Typography, {
  TypographyVariant,
} from '../../../component_library/components/Typography';

interface IProps {
  fontColor?: string;
  bgColor?: string;
  borderBottom?: string;
}

const StockPriceLayout: React.FC<IProps> = ({
  fontColor,
  bgColor,
  borderBottom,
}) => {
  const { theme, latestStockPrice } = useStockPrice();

  return (
    <Box
      sx={{
        borderBottom: `${borderBottom || 'none'}`,
        backgroundColor: `${bgColor || 'transparent'}`,
      }}
    >
      <Typography
        variant={TypographyVariant.SMALL_BODY_REGULAR}
        additionalStyles={{
          color: fontColor || `${theme.colors.secondary}`,
          padding: 0,
          margin: 0,
        }}
      >
        <span
          style={{
            fontWeight: '700',
          }}
        >
          {`${latestStockPrice.symbol}`}
        </span>
        {' '}
        {`${Number(latestStockPrice.price).toFixed(2)} USD`}
      </Typography>
    </Box>
  );
};

export default StockPriceLayout;
